import { CommonModule } from '@angular/common';
import { NgModule, Injectable, Inject, OnInit, ModuleWithProviders  } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { FormsModule } from '@angular/forms';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/map';
import { MaterialModule } from '../../material.module';

import { EquipmentActionsComponent } from './equipment-actions.component';
import { EquipmentActionsService } from './equipment-actions.service';


@NgModule({
    imports: [CommonModule, MaterialModule, FormsModule],
    declarations: [
        EquipmentActionsComponent
    ],
    exports: [EquipmentActionsComponent, MaterialModule]
})
export class EquipmentActionsModule {
    static forRoot(): ModuleWithProviders<EquipmentActionsModule> {
        return {
            ngModule: EquipmentActionsModule,
            providers: [EquipmentActionsService]
        }
    }
}
